// src/pages/VerifyEmail.jsx
import { useLocation } from 'react-router-dom'

export default function VerifyEmail() {
  const loc = useLocation()
  const email = loc.state?.email || ''

  return (
    <div className="max-w-md mx-auto">
      <h1 className="text-xl font-bold mb-2">이메일 확인</h1>
      <div className="rounded-2xl border bg-white p-4 text-sm">
        <p className="mb-2">
          회원가입이 완료되었습니다. 입력하신 이메일로 확인 메일을 보냈습니다.
        </p>
        {email && <p className="text-gray-600">발송 주소: <strong>{email}</strong></p>}
        <ul className="list-disc pl-5 mt-3 text-gray-700 space-y-1">
          <li>메일의 링크를 클릭해 이메일을 확인해 주세요.</li>
          <li>링크 클릭 후 브라우저로 돌아오면 자동 로그인/리디렉션 될 수 있습니다.</li>
          <li>메일이 오지 않았다면 스팸함을 확인하거나, 잠시 후 다시 시도해 주세요.</li>
        </ul>
      </div>
    </div>
  )
}
